/**
 * Used to attach handlers in client/src/scripts/blocks/store/index.jsx
 */
export const STORE_SECTION_PRELOADER_CONTAINER =
  'store-section-preloader-container';
